import { useLayoutEffect } from 'react';

// Fit only the project Flows view. Draft canvases and dialogs keep their own
// sizing. Measuring surrounding layout never reads or changes graph positions.
export default function useProjectDagViewportHeight(containerRef, enabled) {
  useLayoutEffect(() => {
    const container = containerRef.current;
    if (!enabled || !container) return undefined;

    let frame;
    let previousHeight;
    const measure = () => {
      frame = undefined;
      const viewport = window.visualViewport;
      const bottom = viewport ? viewport.offsetTop + viewport.height : window.innerHeight;
      const height = Math.max(160, Math.floor(bottom - container.getBoundingClientRect().top - 12));
      if (height === previousHeight) return;
      previousHeight = height;
      container.style.setProperty('--project-dag-height', `${height}px`);
      container.style.setProperty('--project-dag-min-height', '0px');
    };
    const scheduleMeasure = () => {
      if (frame === undefined) frame = requestAnimationFrame(measure);
    };

    measure();
    const observer = typeof ResizeObserver === 'undefined' ? null : new ResizeObserver(scheduleMeasure);
    // A header can move the canvas without resizing it. Observe the surrounding
    // blocks and preceding siblings, never the graph's nodes or connections.
    for (let element = container; element; element = element.parentElement) {
      observer?.observe(element);
      for (let sibling = element.previousElementSibling; sibling; sibling = sibling.previousElementSibling) {
        observer?.observe(sibling);
      }
    }
    window.addEventListener('resize', scheduleMeasure);
    window.visualViewport?.addEventListener('resize', scheduleMeasure);

    return () => {
      if (frame !== undefined) cancelAnimationFrame(frame);
      observer?.disconnect();
      window.removeEventListener('resize', scheduleMeasure);
      window.visualViewport?.removeEventListener('resize', scheduleMeasure);
      container.style.removeProperty('--project-dag-height');
      container.style.removeProperty('--project-dag-min-height');
    };
  }, [containerRef, enabled]);
}
